import { Divider, Stack } from "@mui/material";
import CategoryCard from "./CategoryCard";
import { AdvancedStatsSectionProps } from "./types";

export default function AdvancedStatsSection({
  offenseMetrics,
  reboundingMetrics,
  defenseMetrics,
}: AdvancedStatsSectionProps) {
  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      spacing={4}
    >
      <CategoryCard metrics={offenseMetrics} layout="2x2" />
      <CategoryCard metrics={reboundingMetrics} layout="1x2" />
      <CategoryCard metrics={defenseMetrics} layout="2x2" />
    </Stack>
  );
}
